import './index.scss';
import errorIcon from 'url:@assets/icons/error-icon.svg'
import { useNavigate } from 'react-router-dom';

export default function ErrorView(
  props: {
    error: string,
    showButton?: boolean,
    buttonText?: string,
    buttonAction?: () => void
  }
) {
  const navigate = useNavigate();

  return <div className="error-view">
    <img src={errorIcon} alt="Error icon" />
    <h1>Error</h1>
    <p>{props.error}</p>

    {props.showButton !== false ? <a href="#" onClick={props.buttonAction ?? (() => navigate(-1))}>{props.buttonText ?? "Go Back"}</a> : null}
  </div>
}